// extracted by mini-css-extract-plugin
export default {"container":"upload_container__S-zVZ","copy":"upload_copy__CbnEZ","copyNoMargin":"upload_copyNoMargin__oZWHm"};